<template>
    <a-card style="max-width: 500px;margin: 0 auto;">
        <a-form
            :model="formModel"
            @finish="onFinish"
            :rules="formRule"
            :scrollToFirstError="true"
            layout="vertical"
        >
            <a-form-item :label="$t('labelText.username')" name="username">
                <a-input v-model:value="formModel.username" :autofocus="true" />
            </a-form-item>

            <a-form-item :label="$t('labelText.password')" name="password">
                <a-input-password v-model:value="formModel.password" />
            </a-form-item>

            <a-form-item name="remember">
                <a-checkbox v-model:checked="formModel.remember">{{ $t('labelText.rememberMe') }}</a-checkbox>
            </a-form-item>

            <a-form-item>
                <a-button type="primary" html-type="submit" block :loading="isLoading">{{ $t('text.login') }}</a-button>
            </a-form-item>
        </a-form>

        <router-link :to="{ name: RouteName.FORGOT_PASSWORD }">{{ $t('text.forgotPassword') }}</router-link>

        <a-divider>{{ $t('text.or') }}</a-divider>

        <a-form-item>
            <a-button type="primary" block ghost>
                <router-link :to="{ name: RouteName.REGISTER }">{{ $t('text.regNewAcc') }}</router-link>
            </a-button>
        </a-form-item>
    </a-card>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import {
    Button, Form, Input, InputPassword, Checkbox, Card, Divider,
} from 'ant-design-vue';

import type { RuleObject } from 'ant-design-vue/lib/form';

import ApiRequest from '@/utils/ApiRequest';
import { RouteName, REDIRECT_QUERY_KEY } from '@/router';
import { StoreMut } from '@/store/modules/user';

interface FormModel {
    username: string;
    password: string;
    remember: boolean;
}

export default defineComponent({
    components: {
        AButton: Button,
        AForm: Form,
        AFormItem: Form.Item,
        AInput: Input,
        AInputPassword: InputPassword,
        ACheckbox: Checkbox,
        ACard: Card,
        ADivider: Divider,
    },

    setup() {
        const router = useRouter();
        const route = useRoute();
        const store = useStore();

        const formModel = reactive<FormModel>({
            username: '',
            password: '',
            remember: true,
        });
        const formRule = reactive<Record<keyof FormModel, RuleObject[]>>({
            username: [
                {
                    required: true,
                    trigger: 'change',
                },
            ],
            password: [
                {
                    required: true,
                    trigger: 'change',
                },
            ],
            remember: [],
        });

        const isLoading = ref(false);

        const onFinish = (values: FormModel) => {
            isLoading.value = true;

            ApiRequest.post('/login', values)
                .then(res => {
                    store.commit(StoreMut.SET_USER, res.data.data);

                    const redirect = route.query[REDIRECT_QUERY_KEY] as string;
                    if (redirect && redirect.length) {
                        // TODO: Check redirect is valid route
                        router.push(redirect);
                        return;
                    }

                    router.push({ name: RouteName.TOP });
                })
                .finally(() => {
                    isLoading.value = false;
                });
        };

        return {
            RouteName,

            onFinish,

            formModel,
            formRule,

            isLoading,
        };
    },
})
</script>
